<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">Recent Form Responses</h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
      [smallSize]="true"
    ></item-picker>
  </div>
  @if (loaded) {
    <div>
      @if (chartData) {
        <div class="chart-container">
          <app-chart-canvas
            [chartData]="chartData"
            [customColors]="color"
          ></app-chart-canvas>
        </div>
      }
      @if (!chartData) {
        <div class="no-content" fxLayout="column" fxLayoutAlign="center center">
          <p>You have no new responses in the last four months.</p>
          <a
            mat-flat-button
            color="primary"
            href="https://support.lineupteams.com/hc/en-us/articles/360038003234-Creating-an-Lineup-Form"
            >Learn More About Forms</a
          >
        </div>
      }
    </div>
  }
  @if (!loaded) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
</div>
